// react
import React, { Component } from 'react';
import { connect } from 'react-redux';
import api from '../../api/client';

// third-party
import classNames from 'classnames';
import PropTypes from 'prop-types';

// application
import ProductTabDescription from './ProductTabDescription';
import ProductTabReviews from './ProductTabReviews';

class ProductTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentTab: 'reviews',
        };

        this.onDownload = this.onDownload.bind(this);
    }

    setTab = (newTab) => {
        this.setState(() => ({ currentTab: newTab }));
    }; 

    onDownload(productId, fileName) {
        return new Promise((resolve, reject) => {
            let urlQuery = `products/technical-sheet-download?product=${productId}&fileName=${fileName}`;
            api.post(urlQuery, {}, { responseType: 'arraybuffer' })
              .then(response => {
      
                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.click();
              })
              .catch(error => {
                console.log(error)
                reject(false);
              });
          });
    }

    render() {
        const { currentTab } = this.state;
        const { withSidebar, product} = this.props;

        const classes = classNames('product-tabs', {
            'product-tabs--layout--sidebar': withSidebar,
        });
        
        let tabs = [
            { key: 'description', title: 'Características', content: <ProductTabDescription product={product} onDownload={this.onDownload}/> },
            /*{ key: 'specification', title: 'Specification', content: <ProductTabSpecification /> },*/
            { key: 'reviews', title: 'Valoraciones', content: <ProductTabReviews product={product}/> },
        ];

        if (product && product.files && product.files.length <= 0 && product.description && product.description.blocks.length <= 0) {
            tabs = [
                /*{ key: 'specification', title: 'Specification', content: <ProductTabSpecification /> },*/
                { key: 'reviews', title: 'Valoraciones', content: <ProductTabReviews product={product}/> },
            ];
        }

        const tabsButtons = tabs.map((tab) => {
            const classes = classNames('product-tabs__item', {
                'product-tabs__item--active': currentTab === tab.key,
            });

            return <button key={tab.key} type="button" onClick={() => this.setTab(tab.key)} className={classes}>{tab.title}</button>;
        });

        const tabsContent = tabs.map((tab) => {
            const classes = classNames('product-tabs__pane', {
                'product-tabs__pane--active': currentTab === tab.key,
            });

            return <div key={tab.key} className={classes}>{tab.content}</div>;
        });

        return (
            <div className={classes}>
                <div className="product-tabs__list">
                    {tabsButtons}
                </div>
                <div className="product-tabs__content">
                    {tabsContent}
                </div>
            </div>
        );
    }
}

ProductTabs.propTypes = {
    withSidebar: PropTypes.bool,
};

ProductTabs.defaultProps = {
    withSidebar: false,
};

const mapStateToProps = ({ settings }) => {

    return {
        settings
    };
};

const mapDispatchToProps = {
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductTabs);
